import { Translate } from 'next-translate'
import { Input } from '@/components/molecules/form/form'
import {
  baseValidator,
  newEmailValidator,
  rangeLengthValidator
} from '@/core/validationUtils'

export enum RegistrationField {
  name = 'name',
  surname = 'surname',
  email = 'email',
  password = 'password'
}

export const makeRegistrationInputFields = (t: Translate): Input[] => [
  {
    title: t('Register.Email.Form.name'),
    name: RegistrationField.name,
    placeholder: t('Register.Email.Form.name'),
    rules: [
      {
        errorMessage: t('Register.Email.Form.invalidFirstnameErrorPlaceholder'),
        isValid: (value) => rangeLengthValidator(1, 32, value)
      }
    ]
  },
  {
    title: t('Register.Email.Form.surname'),
    name: RegistrationField.surname,
    placeholder: t('Register.Email.Form.surname'),
    rules: [
      {
        errorMessage: t('Register.Email.Form.invalidSurnameErrorPlaceholder'),
        isValid: (value) => rangeLengthValidator(1, 32, value)
      }
    ]
  },
  {
    title: t('Register.Email.Form.email'),
    subTitle: t('Register.Email.Form.emailHint'),
    name: RegistrationField.email,
    placeholder: t('Register.Email.Form.email'),
    rules: [
      {
        errorMessage: t('Register.Email.Form.emptyEmailErrorPlaceholder'),
        isValid: baseValidator
      },
      {
        errorMessage: t('Register.Email.Form.notValidEmailErrorPlaceholder'),
        isValid: newEmailValidator
      }
    ]
  },
  {
    title: t('Register.Email.Form.password'),
    subTitle: t('Register.Email.Form.notValidPasswordErrorPlaceholder'),
    name: RegistrationField.password,
    placeholder: t('Register.Email.Form.password'),
    valueType: 'password',
    rules: [
      {
        errorMessage: t('Register.Email.Form.emptyPasswordErrorPlaceholder'),
        isValid: baseValidator
      },
      {
        errorMessage: t('Register.Email.Form.notValidPasswordErrorPlaceholder'),
        isValid: (value) => rangeLengthValidator(8, null, value)
      }
    ]
  }
]
